var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticStyle: { height: "calc(100vh - 80px)", overflow: "scroll" },
          attrs: { fluid: "" }
        },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.statusDialog,
                callback: function($$v) {
                  _vm.statusDialog = $$v
                },
                expression: "statusDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _vm._v("Are you sure you want to update the club status?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.statusDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.updateStatus(_vm.club_id, _vm.status)
                            }
                          }
                        },
                        [_vm._v("OK\n                    ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "400" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  return _vm.cancelUpload($event)
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "headline p-10 elc-clubdetails-dialog-header",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("Import Club\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "p-10" },
                    [
                      _c("div", { staticClass: "p-t-10 p-b-10" }, [
                        _c("p", { staticStyle: { color: "#5d5d5d" } }, [
                          _vm._v("Follow this Format in csv/xls/xlsx file.")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { color: "#5d5d5d" } }, [
                          _c("strong", [_vm._v("Columns")]),
                          _vm._v(
                            " [ ELC Code, ELC Type, Name, Longitude,\n                            Latitude,\n                            Booth, Area, Taluka, District, State, Pincode,\n                            Nodal Officer, Nodal Mobile ]\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs12: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Select File",
                              "prepend-icon": "attach_file"
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.pickFile($event)
                              }
                            },
                            model: {
                              value: _vm.clubFileName,
                              callback: function($$v) {
                                _vm.clubFileName = $$v
                              },
                              expression: "clubFileName"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            ref: "image",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              id: "fileId",
                              accept:
                                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            },
                            on: { input: _vm.onFilePicked }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticStyle: { "text-decoration": "none" },
                          attrs: {
                            href: "../../../static/assets/files/clubs.csv",
                            download: ""
                          }
                        },
                        [_vm._v("click\n                        here")]
                      ),
                      _c("span", { staticStyle: { color: "#5d5d5d" } }, [
                        _vm._v(" to download format of file.")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "p-10 text-sm-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          on: { click: _vm.cancelUpload }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { disabled: _vm.uploadBtnFlag },
                          on: { click: _vm.uploadClub }
                        },
                        [_vm._v("Upload\n                    ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.delDialog,
                callback: function($$v) {
                  _vm.delDialog = $$v
                },
                expression: "delDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _vm._v("Are you sure you want to delete this club?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.delDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.deleteClub()
                            }
                          }
                        },
                        [_vm._v("OK")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.delReqDialog,
                callback: function($$v) {
                  _vm.delReqDialog = $$v
                },
                expression: "delReqDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _vm._v("Are you sure you want to delete this club?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.delReqDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.deleteReqClub()
                            }
                          }
                        },
                        [_vm._v("OK")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: _vm.bulkDelDialog,
                callback: function($$v) {
                  _vm.bulkDelDialog = $$v
                },
                expression: "bulkDelDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _vm._v("Are you sure you want to delete selected club?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.bulkDelDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elc-button-radius-color",
                          attrs: { flat: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.bulkDelete($event)
                            }
                          }
                        },
                        [_vm._v("OK")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                "max-width": "400px",
                "max-height": "600px"
              },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  return _vm.cancelAnnoucementDialog($event)
                }
              },
              model: {
                value: _vm.announcementDialog,
                callback: function($$v) {
                  _vm.announcementDialog = $$v
                },
                expression: "announcementDialog"
              }
            },
            [
              _c(
                "v-form",
                {
                  ref: "formAN",
                  staticStyle: { "text-transform": "capitalize" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: { float: "right !important" },
                              attrs: { slot: "activator", icon: "" },
                              on: { click: _vm.cancelAnnoucementDialog },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("clear")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Close")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "p-10" },
                        [
                          _c("v-card-title", { staticClass: "p-0 p-l-10" }, [
                            _c("span", { staticClass: "headline" }, [
                              _vm._v("Announcement ")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            {
                              staticClass: "p-10",
                              attrs: { "grid-list-md": "" }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _vm.announcementDialog
                                            ? _c("v-text-field", {
                                                attrs: {
                                                  autofocus: "",
                                                  name: "title",
                                                  label: "Title",
                                                  rules: _vm.fieldRules
                                                },
                                                model: {
                                                  value: _vm.title,
                                                  callback: function($$v) {
                                                    _vm.title = $$v
                                                  },
                                                  expression: "title"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          name: "description",
                                          label: "Description"
                                        },
                                        model: {
                                          value: _vm.description,
                                          callback: function($$v) {
                                            _vm.description = $$v
                                          },
                                          expression: "description"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "elc-button-radius",
                              attrs: { flat: "" },
                              on: { click: _vm.cancelAnnoucementDialog }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "elc-button-radius-color",
                              attrs: { flat: "", disabled: _vm.title == "" },
                              on: { click: _vm.addAnnoucement }
                            },
                            [
                              _vm._v(
                                "\n                            Save\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                persistent: "",
                transition: "slide-x-reverse-transition"
              },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  return _vm.cancelEditClubDialog($event)
                }
              },
              model: {
                value: _vm.editClubDialog,
                callback: function($$v) {
                  _vm.editClubDialog = $$v
                },
                expression: "editClubDialog"
              }
            },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-card", { staticClass: "elc-addmember-card" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100vh - 50px)",
                          "overflow-y": "auto"
                        }
                      },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _vm.editClubDialog && !_vm.requestFlag
                                  ? _c("h2", { staticClass: "p-10" }, [
                                      _vm._v(" Update Club ")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.editClubDialog && _vm.requestFlag
                                  ? _c("h2", { staticClass: "p-10" }, [
                                      _vm._v("Add Club ")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "0",
                                      right: "0"
                                    },
                                    attrs: { bottom: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { slot: "activator", icon: "" },
                                        on: { click: _vm.cancelEditClubDialog },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("clear")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Close")])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        rules: _vm.nameRules,
                                        label: "Club Name*",
                                        id: "clubId",
                                        autofocus: "",
                                        required: ""
                                      },
                                      on: { keypress: _vm.isAlphaNumeric },
                                      model: {
                                        value: _vm.club1.club_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "club_name", $$v)
                                        },
                                        expression: "club1.club_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.elc_type,
                                        label: "Club Type*",
                                        "item-text": "value",
                                        "item-value": "id",
                                        rules: _vm.fieldRules
                                      },
                                      model: {
                                        value: _vm.club1.elc_type,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "elc_type", $$v)
                                        },
                                        expression: "club1.elc_type"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Election Code" },
                                      model: {
                                        value: _vm.club1.elc_code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "elc_code", $$v)
                                        },
                                        expression: "club1.elc_code"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Latitude",
                                        mask: "##.##################",
                                        "return-masked-value": "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.latitude,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "latitude", $$v)
                                        },
                                        expression: "club1.latitude"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Longitude",
                                        mask: "##.################",
                                        "return-masked-value": "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.longitude,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "longitude", $$v)
                                        },
                                        expression: "club1.longitude"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Booth" },
                                      model: {
                                        value: _vm.club1.booth,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "booth", $$v)
                                        },
                                        expression: "club1.booth"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        items: _vm.roleOfficers1[0],
                                        label: "Select Nodal Officer*",
                                        "return-object": "",
                                        rules: _vm.fieldRules,
                                        "item-text": "name"
                                      },
                                      on: { change: _vm.changeMobile },
                                      model: {
                                        value: _vm.club1.officers[0],
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1.officers, 0, $$v)
                                        },
                                        expression: "club1.officers[0]"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs2: "", md1: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { disabled: "", label: "+91" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs10: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        mask: _vm.mask,
                                        label: "Nodal Mobile*",
                                        rules: _vm.fieldRules,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.officers[0].phone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.club1.officers[0],
                                            "phone",
                                            $$v
                                          )
                                        },
                                        expression: "club1.officers[0].phone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.clubStatus,
                                        label: "Status",
                                        "item-text": "name",
                                        "item-value": "value"
                                      },
                                      model: {
                                        value: _vm.club1.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "status", $$v)
                                        },
                                        expression: "club1.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Pincode*",
                                        mask: "######",
                                        rules: _vm.pinCodeRules,
                                        required: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.getArea(_vm.club1.pincode)
                                        }
                                      },
                                      model: {
                                        value: _vm.club1.pincode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "pincode", $$v)
                                        },
                                        expression: "club1.pincode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Area" },
                                      model: {
                                        value: _vm.club1.area,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "area", $$v)
                                        },
                                        expression: "club1.area"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.taluka,
                                        label: "Taluka*",
                                        rules: _vm.fieldRules,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.taluka,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "taluka", $$v)
                                        },
                                        expression: "club1.taluka"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "District*",
                                        rules: _vm.nameRules,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.district,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "district", $$v)
                                        },
                                        expression: "club1.district"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 text-sm-right",
                                    attrs: { xs12: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "elc-button-radius",
                                        on: { click: _vm.cancelEditClubDialog }
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _vm._v(" "),
                                    _vm.editClubDialog && !_vm.requestFlag
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "elc-button-radius-color",
                                            attrs: { disabled: !_vm.valid },
                                            on: { click: _vm.updateClub }
                                          },
                                          [
                                            _vm._v(
                                              "Update\n                                    "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.editClubDialog && _vm.requestFlag
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "elc-button-radius-color",
                                            attrs: {
                                              disabled:
                                                _vm.club1.club_name == "" ||
                                                _vm.club1.elc_type == "" ||
                                                _vm.club1.pincode == "" ||
                                                _vm.club1.taluka == "" ||
                                                _vm.club1.district == "" ||
                                                _vm.club1.officers == [] ||
                                                !_vm.valid
                                            },
                                            on: { click: _vm.updateClub }
                                          },
                                          [
                                            _vm._v(
                                              "Approve\n                                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                persistent: "",
                transition: "slide-x-reverse-transition"
              },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  _vm.detailsDialog = false
                }
              },
              model: {
                value: _vm.detailsDialog,
                callback: function($$v) {
                  _vm.detailsDialog = $$v
                },
                expression: "detailsDialog"
              }
            },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-card", { staticClass: "elc-addmember-card" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100vh - 50px)",
                          "overflow-y": "auto"
                        }
                      },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c("h2", { staticClass: "p-10" }, [
                                  _vm._v(" Club Details ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "0",
                                      right: "0"
                                    },
                                    attrs: { bottom: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { slot: "activator", icon: "" },
                                        on: {
                                          click: function($event) {
                                            _vm.detailsDialog = false
                                          }
                                        },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("clear")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Close")])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Club Name*",
                                        readonly: "",
                                        id: "clubId",
                                        autofocus: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.club_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "club_name", $$v)
                                        },
                                        expression: "club1.club_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        readonly: "",
                                        items: _vm.constant.elc_type,
                                        label: "Club Type*",
                                        rules: _vm.fieldRules,
                                        "item-text": "value",
                                        "item-value": "id"
                                      },
                                      model: {
                                        value: _vm.club1.elc_type,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "elc_type", $$v)
                                        },
                                        expression: "club1.elc_type"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "Election Code"
                                      },
                                      model: {
                                        value: _vm.club1.elc_code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "elc_code", $$v)
                                        },
                                        expression: "club1.elc_code"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "Latitude",
                                        mask: "##.##################",
                                        "return-masked-value": "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.latitude,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "latitude", $$v)
                                        },
                                        expression: "club1.latitude"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "Longitude",
                                        mask: "##.##################",
                                        "return-masked-value": "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.longitude,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "longitude", $$v)
                                        },
                                        expression: "club1.longitude"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "Booth",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.booth,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "booth", $$v)
                                        },
                                        expression: "club1.booth"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md4: "" }
                                  },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        readonly: "",
                                        items: _vm.club1.officers[0],
                                        label: "Select Nodal Officer*",
                                        "return-object": "",
                                        "item-text": "name"
                                      },
                                      on: { change: _vm.changeMobile },
                                      model: {
                                        value: _vm.club1.officers[0],
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1.officers, 0, $$v)
                                        },
                                        expression: "club1.officers[0]"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs2: "", md1: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { disabled: "", label: "+91" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs10: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        mask: _vm.mask,
                                        label: "Nodal Mobile*",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.officers[0].phone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.club1.officers[0],
                                            "phone",
                                            $$v
                                          )
                                        },
                                        expression: "club1.officers[0].phone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        readonly: "",
                                        items: _vm.clubStatus,
                                        label: "Status",
                                        "item-text": "name",
                                        "item-value": "value"
                                      },
                                      model: {
                                        value: _vm.club1.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "status", $$v)
                                        },
                                        expression: "club1.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "Pincode*",
                                        mask: "######",
                                        required: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.getArea(_vm.club1.pincode)
                                        }
                                      },
                                      model: {
                                        value: _vm.club1.pincode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "pincode", $$v)
                                        },
                                        expression: "club1.pincode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { readonly: "", label: "Area" },
                                      model: {
                                        value: _vm.club1.area,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "area", $$v)
                                        },
                                        expression: "club1.area"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        readonly: "",
                                        items: _vm.constant.taluka,
                                        label: "Taluka*",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.taluka,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "taluka", $$v)
                                        },
                                        expression: "club1.taluka"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10 elc-officer-dialog",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        readonly: "",
                                        label: "District*",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.club1.district,
                                        callback: function($$v) {
                                          _vm.$set(_vm.club1, "district", $$v)
                                        },
                                        expression: "club1.district"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "elc-card-club-count" },
            [
              _vm.user.officer_role === 1 || _vm.user.officer_role === 5
                ? _c(
                    "v-card",
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "elc-tabs",
                          attrs: { "fixed-tabs": "" }
                        },
                        [
                          _c("v-tab", [_vm._v(" Clubs")]),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "p-10" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c("v-flex", {
                                        attrs: {
                                          xs12: "",
                                          sm6: "",
                                          md3: "",
                                          lg5: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm6: "",
                                            md3: "",
                                            lg2: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "p-t-10 p-b-10" },
                                            [
                                              _vm.selected.length != 0
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "elc-button-radius-color",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.openBulkDelDialog(
                                                            "Clubs"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Delete Selected\n                                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm6: "",
                                            md3: "",
                                            lg3: ""
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "append-icon": "search",
                                              label: "Search",
                                              "single-line": "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.search,
                                              callback: function($$v) {
                                                _vm.search = $$v
                                              },
                                              expression: "search"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "text-xs-right",
                                          attrs: {
                                            xs12: "",
                                            sm6: "",
                                            md3: "",
                                            lg2: ""
                                          }
                                        },
                                        [
                                          _vm.roleOfficers.length != 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "p-l-10 p-r-10"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "elc-button-radius-color",
                                                      on: {
                                                        click: _vm.importClub
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Import\n                                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    { attrs: { bottom: "" } },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "elc-button-rounded",
                                                          attrs: {
                                                            slot: "activator",
                                                            fab: ""
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.redirectToAddNewClub
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: ""
                                                              }
                                                            },
                                                            [_vm._v("add")]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Add Club")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "p-l-10 p-r-10"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "elc-button-radius-color",
                                                      on: {
                                                        click:
                                                          _vm.openNoOfficerDialog
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Import\n                                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    { attrs: { bottom: "" } },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "elc-button-rounded",
                                                          attrs: {
                                                            slot: "activator",
                                                            fab: ""
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.openNoOfficerDialog
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: ""
                                                              }
                                                            },
                                                            [_vm._v("add")]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Add Club")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-data-table",
                                {
                                  staticClass: "elc-deta-table fixed-header",
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.clubDetails,
                                    loading: _vm.loading,
                                    "select-all": "",
                                    "no-data-text": _vm.loading
                                      ? ""
                                      : "No clubs available",
                                    "item-key": "club_id",
                                    "hide-actions": "",
                                    "disable-initial-sort": true
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: props.selected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props,
                                                      "selected",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "props.selected"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "elc-sentence_capitalize",
                                              staticStyle: {
                                                cursor: "pointer !important",
                                                "word-break": "break-word"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.club_name) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                cursor: "pointer !important"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.constant.elc_type_const[
                                                      props.item.elc_type
                                                    ]
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "right!important"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item
                                                        .memberVerifyCount
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "right!important"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.member_count -
                                                        props.item
                                                          .memberVerifyCount
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          props.item.elc_code
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        props.item.elc_code
                                                      ) +
                                                      "\n\n                                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "-\n                                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          props.item.booth != null
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(props.item.booth) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    -\n                                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                cursor: "pointer !important"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.pincode) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          props.item.area != null
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(props.item.area) +
                                                      "\n\n                                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.gotoMembers(
                                                        props.item,
                                                        props.item.club_id,
                                                        props.item.club_name
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "-\n                                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                cursor: "pointer !important"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.taluka) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "text-align": "right!important",
                                                cursor: "pointer !important"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    props.item
                                                      .connectlyMemberCount
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.gotoMembers(
                                                    props.item,
                                                    props.item.club_id,
                                                    props.item.club_name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("v-switch", {
                                                staticStyle: {
                                                  height: "35px !important",
                                                  cursor: "default !important"
                                                },
                                                attrs: { readonly: "" },
                                                on: {
                                                  change: function($event) {
                                                    _vm.updateStatusDialog(
                                                      props.item.club_id,
                                                      props.item.booleanStatus
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    props.item.booleanStatus,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.item,
                                                      "booleanStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "props.item.booleanStatus"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "layout justify-center",
                                              staticStyle: {
                                                padding: "5px 0px !important"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    transition:
                                                      "slide-x-transition",
                                                    bottom: "",
                                                    right: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        slot: "activator",
                                                        icon: ""
                                                      },
                                                      slot: "activator"
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("more_horiz")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.openAnnouncementDelDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Announcement\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.openEditDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Edit\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.openDelDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Delete\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.selected,
                                    callback: function($$v) {
                                      _vm.selected = $$v
                                    },
                                    expression: "selected"
                                  }
                                },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        slot: "no-results",
                                        value: true,
                                        color: "error",
                                        icon: "warning"
                                      },
                                      slot: "no-results"
                                    },
                                    [
                                      _vm._v(
                                        '\n                                Your search for "' +
                                          _vm._s(_vm.search) +
                                          '" found no results.\n                            '
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.totalCount > _vm.count
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-xs-center pt-2",
                                        staticStyle: {
                                          position: "fixed",
                                          bottom: "50px",
                                          width: "96vw"
                                        }
                                      },
                                      [
                                        _c("v-pagination", {
                                          attrs: {
                                            color: "#515a75",
                                            circle: "",
                                            length: _vm.totalPage,
                                            "total-visible": 7
                                          },
                                          on: { input: _vm.pagination },
                                          model: {
                                            value: _vm.page,
                                            callback: function($$v) {
                                              _vm.page = $$v
                                            },
                                            expression: "page"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            [
                              _vm._v(
                                " Club Joining Request\n                        "
                              ),
                              _vm.clubReqDetails.length != 0
                                ? [
                                    _c(
                                      "v-badge",
                                      {
                                        staticStyle: {
                                          margin: "0px 0px 40px 0px !important"
                                        },
                                        attrs: { right: "", color: "red" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "badge" },
                                            slot: "badge"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.totalClubReqCount)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : void 0
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass: "p-10",
                                  staticStyle: {
                                    padding: "20px 10px !important"
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c("v-flex", {
                                        attrs: {
                                          xs12: "",
                                          sm6: "",
                                          md3: "",
                                          lg5: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-flex", {
                                        attrs: {
                                          xs12: "",
                                          sm6: "",
                                          md3: "",
                                          lg2: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm6: "",
                                            md3: "",
                                            lg2: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _vm.reqSelected.length != 0
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "elc-button-radius-color",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.openBulkDelDialog(
                                                            "ClubReq"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Delete Selected\n                                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "text-xs-right",
                                          attrs: {
                                            xs12: "",
                                            sm6: "",
                                            md3: "",
                                            lg3: ""
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "append-icon": "search",
                                              label: "Search",
                                              "single-line": "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.searchReq,
                                              callback: function($$v) {
                                                _vm.searchReq = $$v
                                              },
                                              expression: "searchReq"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-data-table",
                                {
                                  staticClass: "elc-deta-table fixed-header",
                                  attrs: {
                                    headers: _vm.headersJoinReq,
                                    items: _vm.clubReqDetails,
                                    loading: _vm.loading,
                                    search: _vm.searchReq,
                                    "no-data-text": _vm.loading
                                      ? ""
                                      : "No clubs available",
                                    "select-all": "",
                                    "hide-actions": "",
                                    "disable-initial-sort": true,
                                    "item-key": "club_id"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: props.selected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props,
                                                      "selected",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "props.selected"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "elc-sentence_capitalize",
                                              staticStyle: {
                                                cursor: "pointer !important",
                                                "word-break": "break-word"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.club_name) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "elc-sentence_capitalize",
                                              staticStyle: {
                                                cursor: "pointer !important",
                                                "word-break": "break-word"
                                              }
                                            },
                                            [
                                              props.item.clubMember
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          props.item.clubMember
                                                            .name
                                                        ) +
                                                        " (" +
                                                        _vm._s(
                                                          props.item.clubMember
                                                            .phone
                                                        ) +
                                                        ")"
                                                    )
                                                  ])
                                                : _c("span", [_vm._v("-")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                cursor: "pointer !important"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.pincode) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          props.item.area != null
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(props.item.area) +
                                                      "\n\n                                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer !important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "-\n                                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                cursor: "pointer !important"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(props.item.taluka) +
                                                  "\n\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "5px 0px !important"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    transition:
                                                      "slide-x-transition",
                                                    bottom: "",
                                                    right: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        slot: "activator",
                                                        icon: ""
                                                      },
                                                      slot: "activator"
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("more_horiz")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.openRequestDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Verify Club\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.openDelReqDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Delete\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.reqSelected,
                                    callback: function($$v) {
                                      _vm.reqSelected = $$v
                                    },
                                    expression: "reqSelected"
                                  }
                                },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        slot: "no-results",
                                        value: true,
                                        color: "error",
                                        icon: "warning"
                                      },
                                      slot: "no-results"
                                    },
                                    [
                                      _vm._v(
                                        '\n                                Your search for "' +
                                          _vm._s(_vm.search) +
                                          '" found no results.\n                            '
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.totalClubReqCount > _vm.pagiReqCount
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-xs-center pt-2",
                                        staticStyle: {
                                          position: "fixed",
                                          bottom: "50px",
                                          width: "96vw"
                                        }
                                      },
                                      [
                                        _c("v-pagination", {
                                          attrs: {
                                            color: "#515a75",
                                            circle: "",
                                            length: _vm.totalReqPage,
                                            "total-visible": 7
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.pagination("JoinReq")
                                            }
                                          },
                                          model: {
                                            value: _vm.reqPage,
                                            callback: function($$v) {
                                              _vm.reqPage = $$v
                                            },
                                            expression: "reqPage"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "p-10" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "", sm9: "" } }, [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "500",
                                      "font-size": "22px",
                                      color: "#596363"
                                    }
                                  },
                                  [_vm._v("ELC Clubs")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Search",
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-data-table",
                        {
                          staticClass:
                            "elc-deta-table elc-club-table fixed-header-view",
                          attrs: {
                            headers: _vm.headersView,
                            items: _vm.clubDetails,
                            loading: _vm.loading,
                            "no-data-text": _vm.loading
                              ? ""
                              : "No clubs available",
                            "hide-actions": "",
                            "disable-initial-sort": true
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "elc-sentence_capitalize",
                                      staticStyle: {
                                        cursor: "pointer !important",
                                        "word-break": "break-word"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.gotoMembers(
                                            props.item,
                                            props.item.club_id,
                                            props.item.club_name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.club_name) +
                                          "\n\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.gotoMembers(
                                            props.item,
                                            props.item.club_id,
                                            props.item.club_name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.elc_type_name) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "text-align": "right!important"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(props.item.memberVerifyCount)
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "text-align": "right!important"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              props.item.member_count -
                                                props.item.memberVerifyCount
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  props.item.elc_code
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.elc_code) +
                                              "\n\n                        "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("-\n                        ")]
                                      ),
                                  _vm._v(" "),
                                  props.item.booth != null
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.booth) +
                                              "\n\n                        "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("-\n                        ")]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.gotoMembers(
                                            props.item,
                                            props.item.club_id,
                                            props.item.club_name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.pincode) +
                                          "\n\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  props.item.area != null
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.area) +
                                              "\n\n                        "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.gotoMembers(
                                                props.item,
                                                props.item.club_id,
                                                props.item.club_name
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("-\n                        ")]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.gotoMembers(
                                            props.item,
                                            props.item.club_id,
                                            props.item.club_name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.taluka) +
                                          "\n\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        "text-align": "right!important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            props.item.connectlyMemberCount
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.gotoMembers(
                                            props.item,
                                            props.item.club_id,
                                            props.item.club_name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-switch", {
                                        staticStyle: {
                                          height: "35px !important",
                                          cursor: "auto"
                                        },
                                        attrs: { readonly: "" },
                                        on: {
                                          change: function($event) {
                                            _vm.updateStatusDialog(
                                              props.item.club_id,
                                              props.item.booleanStatus
                                            )
                                          }
                                        },
                                        model: {
                                          value: props.item.booleanStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "booleanStatus",
                                              $$v
                                            )
                                          },
                                          expression: "props.item.booleanStatus"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                slot: "no-results",
                                value: true,
                                color: "error",
                                icon: "warning"
                              },
                              slot: "no-results"
                            },
                            [
                              _vm._v(
                                '\n                        Your search for "' +
                                  _vm._s(_vm.search) +
                                  '" found no results.\n                    '
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalCount > _vm.count
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "text-xs-center pt-2",
                                staticStyle: {
                                  position: "fixed",
                                  bottom: "50px",
                                  width: "96vw"
                                }
                              },
                              [
                                _c("v-pagination", {
                                  attrs: {
                                    color: "#515a75",
                                    length: _vm.totalPage,
                                    circle: "",
                                    "total-visible": 7
                                  },
                                  on: { input: _vm.pagination },
                                  model: {
                                    value: _vm.page,
                                    callback: function($$v) {
                                      _vm.page = $$v
                                    },
                                    expression: "page"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm.addFlag
            ? _c(
                "div",
                [
                  _c("add-club", {
                    attrs: {
                      clubDialog: _vm.addClubDialog,
                      nodalOfficerArr: _vm.roleOfficers
                    },
                    on: {
                      closeClubDialog: _vm.cancelClubDialog,
                      saveClub: _vm.saveClub
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("alert-modal", {
            attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
            on: {
              closeAlert: function($event) {
                _vm.alertDialog = false
              }
            }
          }),
          _vm._v(" "),
          _vm.uploadProgressPopup ? _c("progress-dialog") : _vm._e(),
          _vm._v(" "),
          _vm.uploadStatusPopup
            ? _c("upload-status-dialog", {
                attrs: {
                  successArr: _vm.successRecordArr,
                  failArr: _vm.failRecordArr
                },
                on: {
                  closeDialog: function($event) {
                    _vm.uploadStatusPopup = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f36fb818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f36fb818","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Club/Clubs.vue
// module id = null
// module chunks = 